import './_terms.scss';

const ComplaintsPolicy = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">Complaints Policy</h2>
            <div className="pf-page__descr">
            <p>
              This policy sets out our complaints policy. If you are a User of <a href='/' className='terms-link'>www.allfans.com</a> (“Website”), this 
              policy forms part of your agreement with us. Defined terms have the same meanings as in our <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
            </p>

            </div>
          <ol className="pf-main-list">
            <li><h5>Applicability</h5>
              <p>Whether or not you are a User, you can use this policy to alert us to any complaint 
                that you have relating to the Website.</p>
            </li>
            <li>  
              <h5>How to Make a Complaint</h5>
              <p>
                If you have a complaint about the Website (including any complaint about Content appearing on the Website or the 
                conduct of a User), please send your complaint to abuse@allfans.com, including your name, address, contact details, 
                a description of your complaint, and, if your complaint relates to Content, the URL for the Content to which your 
                complaint relates. If you cannot contact us by email, please write to us at the mailing address identified in section 7.
              </p>
            </li>
            <li>
              <h5>Complaints of Illegal or Nonconsensual Content</h5>
              <p>
                After receiving your complaint of illegal or nonconsensual Content under section 2, 
                (1) we will in good faith investigate your complaint, and all reported complaints 
                WILL BE resolved within 5 business days; (2) if we require further information or 
                documents from you, we will contact you to let you know; (3) if we are satisfied that 
                the Content is unlawful or nonconsensual, we will immediately remove that Content, 
                and we will notify you of our decision by email or other electronic message; and 
                (4) if we are satisfied that the Content is not unlawful or nonconsensual, we will 
                notify you of our decision by email or other electronic message. Any dispute regarding 
                our determination that Content is nonconsensual will be submitted by us to a neutral 
                arbitration association at our expense.
              </p>
              </li>
            <li>
              <h5>Content Removal Policy</h5>
              <p>
                Innodev Solutions Inc ("AllFans") have the absolute right to remove any Content that we believe, in our sole 
                discretion, may violate any law or the Innodev Solutions Inc ("AllFans") <a href='/terms' className='termslink'>Terms of Service</a>. We comply with all 
                applicable laws regarding the use of proportionate measures to quickly remove illegal Content when we 
                become aware it is on our Site. We are not responsible for any loss you claim to have suffered because 
                of any action we take, in accordance with Innodev Solutions Inc ("AllFans") <a href='/terms' className='termslink'>Terms of Service</a>, to remove 
                Content.  
              </p>
              <p>
                Content Moderation and Removal: All Content is reviewed prior to being published and regularly 
                monitored to ensure all Content complies with the Innodev Solutions Inc ("AllFans") <a href='/terms' className='termslink'>Terms of Service</a> and 
                applicable laws. Any violative Content, including without limitation, Content that is harmful, unlawful, 
                offensive, or otherwise objectionable, will be rejected and/or immediately removed from the Site. If you 
                identify content you believe to be violating any of the <a href='/terms' className='termslink'>Terms of Service</a> or Innodev Solutions Inc ("AllFans"), 
                please immediately report it by emailing <a href='mailto:support@allfans.com' className='termslink'>support@allfans.com</a>.
              </p>
              <p>
                For any other requests for removal of Content, please email us at <a href='mailto:support@allfans.com' className='termslink'>support@allfans.com</a>. Include as much 
                information so we can investigate the removal request, such as name of 
                location on site, brief description, date and time of identification and any relevant URLs and or 
                screenshots. If a request is missing important information, we may not be able to properly investigate 
                the claim to remove the content. 
              </p>
              <p>
                We review all requests for content removal as soon as practicable but in no event more than five (5) 
                business days.
              </p>
              </li>
            <li>
              <h5>Complaints of Copyright Infringement</h5>
              <p>
                Complaints related to copyright infringement must be submitted to our copyright agent in 
                accordance with our <a href='/dmca' className='terms-link'>DMCA Policy</a>, and we will respond to copyright infringement complaints 
                as set out in that policy.
              </p>
              </li>
            <li>
              <h5>All Other Complaints</h5>
              <p>
                After receiving any other complaint (including complaints related to other breaches of 
                the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, the <a href='/creatorterms' className='terms-link'>Creator Terms</a>, 
                or the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>) under 
                section 2, (1) we will take those steps as we consider to be appropriate to investigate your 
                complaint within a timeframe that is appropriate to the nature of your complaint; (2) if we 
                require further information or documents from you, we will contact you to let you know; and 
                (3) we will in good faith take those actions as we consider appropriate to deal with the issue 
                that your complaint has raised. If you have complained about the Content that appears on the 
                Website and we are satisfied that the Content otherwise breaches the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>, 
                the <a href='/creatorterms' className='terms-link'>Creator Terms</a>, or 
                the <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>, we will act promptly 
                to remove that Content. We are not required to inform you of the outcome of your complaint.
              </p>
            </li>
            <li>
              <h5>Unjustified or Abusive Complaints</h5>
              <p>
                If you are a User, you state that you will not make any complaint under this policy that is 
                wholly unjustified, abusive, or made in bad faith. If we determine that you have breached this 
                warranty, we may suspend or terminate your User account.
              </p>
            </li>
            <li>
              <h5>Contact Information</h5>
              <p>
                The Website is owned and operated by Innodev Solutions Inc., a Delaware corporation. You can 
                write to us at 2108 N ST #6819, SACRAMENTO, CA 95816 or at abuse@allfans.com. All notices of copyright infringement 
                claims should be sent to the copyright agent designated in our <a href='/dmca' className='terms-link'>DMCA Policy</a> in the manner and by 
                the means set out in it.
              </p>
            </li>
            <div style={{ paddingTop: '200px' }}></div>
          </ol>
          </div>
          </div>
          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default ComplaintsPolicy;
